import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
// components
import LogsPanel from '@/modules/Analytics/components/LogsPanel';
import AnalyticsTrigger from '@/modules/Analytics/components/AnalyticsTrigger';
// utils
import useAnalyticsStore from '@/modules/Analytics/Analytics.store.ts';
import { useMyRole } from '@/hooks/useMyRole';
// assets
import styles from '@/components/Layout/components/MainContent/MainContent.module.css';

interface MainContentProps {
    children: React.ReactNode;
}

const MainContent = ({ children }: MainContentProps) => {
    const isAnalyticsOpened = useAnalyticsStore(
        (state) => state.isAnalyticsOpened
    );
    const { isTechnicalSupport, isLoading } = useMyRole();
    const isAnalyticsDisabled = !isLoading && isTechnicalSupport;

    return (
        <>
            <PanelGroup className={styles.group} direction="vertical">
                <Panel className={styles.content} id="nw-content">
                    <main className={styles.main}>{children}</main>
                </Panel>
                {isAnalyticsOpened && !isAnalyticsDisabled ? (
                    <>
                        <PanelResizeHandle className="h-0.5 bg-gray-5" />
                        <Panel id="nw-analytics" order={2}>
                            <LogsPanel />
                        </Panel>
                    </>
                ) : undefined}
            </PanelGroup>
            {!isTechnicalSupport && <AnalyticsTrigger />}
        </>
    );
};

export default MainContent;
